var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOpen = function SvgOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.22 10.779a.75.75 0 0 0 1.06 0L18.5 6.561v3.627a.75.75 0 0 0 1.5 0V4.75a.75.75 0 0 0-.75-.75H13.81a.75.75 0 1 0 0 1.5h3.627L13.22 9.718a.75.75 0 0 0 0 1.061M10.779 13.22a.75.75 0 0 0-1.06 0L5.5 17.438v-3.627a.75.75 0 0 0-1.5 0v5.438c0 .414.336.75.75.75h5.438a.75.75 0 0 0 0-1.5H6.56l4.218-4.219a.75.75 0 0 0 0-1.06",
    clipRule: "evenodd"
  })));
};
export default SvgOpen;